export const WIDGET_STYLES = `
:host, * {
  box-sizing: border-box;
}

.vai-root {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  color: #1a1a1a;
}

/* --- Tetikleyici: arama çubuğu görünümlü, sabit köşe pill --- */
.vai-trigger {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 300px;
  max-width: calc(100vw - 24px);
  padding: 6px 8px 6px 16px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #e8e8e8;
  cursor: pointer;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.14);
  z-index: 2147483000;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.vai-trigger:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.vai-trigger-icon {
  color: #111;
  flex-shrink: 0;
  display: flex;
}

.vai-trigger-label {
  flex: 1;
  color: #8a8a8a;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vai-trigger-send {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #111;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* --- Panel --- */
.vai-panel {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 380px;
  max-width: calc(100vw - 24px);
  height: 600px;
  max-height: calc(100vh - 40px);
  background: #fdfdfc;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 2147483000;
}

@media (max-width: 480px) {
  .vai-panel {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
    bottom: 0;
    right: 0;
    border-radius: 0;
  }
}

.vai-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #111;
  color: #fff;
  flex-shrink: 0;
}

.vai-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vai-header-title {
  font-weight: 600;
  font-size: 15px;
}

.vai-close {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 4px;
  display: flex;
  opacity: 0.75;
  border-radius: 6px;
}

.vai-close:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1);
}

.vai-body {
  flex: 1;
  overflow-y: auto;
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* --- Karşılama ekranı --- */
.vai-welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  padding: 20px 8px 8px;
}

.vai-welcome-badge {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #111;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vai-welcome-heading {
  font-size: 17px;
  font-weight: 700;
  color: #111;
}

.vai-capabilities {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.vai-capability {
  font-size: 13.5px;
  color: #444;
  padding: 4px 0;
}

.vai-welcome-prompt {
  font-size: 12.5px;
  color: #999;
  margin-top: 4px;
}

.vai-message {
  max-width: 85%;
  padding: 10px 13px;
  border-radius: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.vai-message-user {
  align-self: flex-end;
  background: #111;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.vai-message-assistant {
  align-self: flex-start;
  background: #f0efec;
  color: #1a1a1a;
  border-bottom-left-radius: 4px;
}

.vai-typing {
  align-self: flex-start;
  background: #f0efec;
  border-radius: 14px;
  border-bottom-left-radius: 4px;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
}

.vai-typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #999;
  animation: vai-blink 1.2s infinite ease-in-out;
}

.vai-typing span:nth-child(2) { animation-delay: 0.2s; }
.vai-typing span:nth-child(3) { animation-delay: 0.4s; }

@keyframes vai-blink {
  0%, 80%, 100% { opacity: 0.3; }
  40% { opacity: 1; }
}

/* --- Ürün önerileri: yatay kaydırmalı kart satırı --- */
.vai-products {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  /* .vai-body bir flex-column; overflow tanımlı olduğu için bu satırın otomatik minimum
     boyutu 0'a düşüyor ve gövde taştıkça kartlar ezilip boş kutulara dönüşüyordu. */
  flex-shrink: 0;
  align-self: stretch;
  padding-bottom: 4px;
  margin: 0 -16px;
  padding-left: 16px;
  padding-right: 16px;
  scrollbar-width: thin;
}

.vai-product-card {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 152px;
  border: 1px solid #ececec;
  border-radius: 14px;
  padding: 10px;
  background: #fff;
  gap: 6px;
}

.vai-product-image {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  object-fit: cover;
  background: #f1f1f1;
}

.vai-product-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #111;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 2.6em;
}

.vai-product-price {
  font-size: 13px;
  color: #111;
  font-weight: 700;
}

.vai-product-reason {
  font-size: 11px;
  color: #777;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.vai-product-link {
  margin-top: auto;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: #111;
  padding: 7px 10px;
  border-radius: 999px;
  text-decoration: none;
}

.vai-product-link:hover {
  background: #2a2a2a;
}

.vai-footer {
  flex-shrink: 0;
  border-top: 1px solid #eee;
  background: #fdfdfc;
}

.vai-input-row {
  display: flex;
  gap: 8px;
  padding: 12px 12px 8px;
}

.vai-input {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 999px;
  padding: 9px 14px;
  font-size: 13px;
  outline: none;
  font-family: inherit;
  background: #fff;
}

.vai-input:focus {
  border-color: #111;
}

.vai-send {
  border: none;
  background: #111;
  color: #fff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.vai-send:disabled {
  opacity: 0.4;
  cursor: default;
}

.vai-legal {
  padding: 0 14px 12px;
  font-size: 10.5px;
  color: #999;
  line-height: 1.5;
}

.vai-legal a {
  color: #999;
  text-decoration: underline;
}
`;
